import React from 'react';

import { cn } from '@/lib/utils';

import { ActivityHeader } from './ActivityHeader';

export interface ActivityItemProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  timestamp: Date | string;
  user?: {
    name: string;
    avatarUrl?: string;
    avatarIcon?: React.ReactNode;
  };
  body?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const ActivityItem: React.FC<ActivityItemProps> = ({
  icon,
  title,
  timestamp,
  user,
  body,
  actions,
  className,
}) => {
  return (
    <div className={cn('px-4 py-4', className)}>
      <ActivityHeader
        icon={icon}
        title={title}
        timestamp={timestamp}
        user={user}
      />
      {body && body}
      {actions && actions}
    </div>
  );
};
